import { BasketItem } from './basketItem';
import { SessionLocation } from './sessionLocation';
import z from 'zod';

export const SessionMonitorTicket = z.object({
    assignedOn: z.coerce.date().nullish(),
    assignedTo: z.string().optional(),
    availableImages: z.string().nullish(),
    category: z.string(),
    closedOn: z.coerce.date().nullish(),
    correlationGuids: z.string().array(),
    deviceId: z.string(),
    id: z.string(),
    message: z.string().nullish(),
    modifiedOn: z.coerce.date().nullish(),
    openedOn: z.coerce.date().nullish(),
    originSeverity: z.int().nullish(),
    session: z.unknown().nullish(),
    sessionGuid: z.string(),
    severity: z.int(),
    status: z.int(),
    storeGuid: z.string(),
    type: z.int(),
});
export type SessionMonitorTicket = z.infer<typeof SessionMonitorTicket>;

export const SessionMonitorSessionHistoryItem = z.object({
    actualWeight: z.int().nullish(),
    availableImages: z.string().array().nullish(),
    basketItem: BasketItem,
    changeGuid: z.string(),
    changeSeq: z.int(),
    createdOn: z.string(),
    delta: z.int(),
    expectedWeight: z.int().nullish(),
    id: z.string(),
    images: z.string().array().nullish(),
    modifiedOn: z.string().nullish(),
    newAmount: z.int(),
    oldAmount: z.int(),
    receivedOn: z.date(),
    time: z.string(),
    type: z.string(),
    weightAdjustments: z.unknown().array().nullish(),
});
export type SessionMonitorSessionHistoryItem = z.infer<typeof SessionMonitorSessionHistoryItem>;

export const SessionMonitorSessionDeviceMetadata = z.object({
    id: z.unknown().nullish(),
    hwVersion: z.string().nullish(),
    hasScale: z.string().nullish(),
});
export type SessionMonitorSessionDeviceMetadata = z.infer<typeof SessionMonitorSessionDeviceMetadata>;

export const SessionMonitorSession = z.object({
    sessionGuid: z.string(),
    storeGuid: z.string(),
    actualWeight: z.number().nullish(),
    cartId: z.string().nullish(),
    closedBy: z.string().nullish(),
    coupons: z.object().array().nullish(),
    customer: z
        .object({
            labels: z.string().array().nullish(),
            risk: z.string().nullish(),
        })
        .nullish(),
    currency: z.string().nullish(),
    deviceId: z.string(),
    deviceMetadata: SessionMonitorSessionDeviceMetadata.nullish(),
    error: z.unknown().nullish(),
    events: z
        .object({
            id: z.string(),
        })
        .array()
        .nullish(),
    expectedWeight: z.number().nullish(),
    history: SessionMonitorSessionHistoryItem.array().nullish(),
    imageDetectionConfirmations: z.unknown().nullish(),
    imageDetections: z.unknown().nullish(),
    isAnonymous: z.boolean().nullish(),
    isBookmarked: z.boolean().nullish(),
    isDemoModeOn: z.boolean().nullish(),
    isLoading: z.boolean().nullish(),
    isMobile: z.boolean().nullish(),
    isSuspicious: z.boolean().nullish(),
    location: SessionLocation.nullish(),
    loginHash: z.string().nullish(),
    loginType: z.string(),
    manualCheck: z
        .object({
            force: z.boolean().nullish(),
            forced: z.boolean().nullish(),
        })
        .nullish(),
    scaleTriggers: z.unknown().array().nullish(),
    sessionEndImages: z.string().array().nullish(),
    sessionStartImages: z.string().array().nullish(),
    sessionModifiedOn: z.string().nullish(),
    showDurationAndPrice: z.unknown().nullish(),
    startedOn: z.string().nullish(),
    taras: z.unknown().array().nullish(),
    targetGuid: z.string().nullish(),
    tenant: z.string().nullish(),
    tickets: SessionMonitorTicket.array().nullish(),
    type: z.string().nullish(),
    total: z.number().nullish(),
    userGuid: z.string().nullish(),
    weightDeviations: z.unknown().nullish(),
    weightWithoutScanAlerts: z.unknown().array().nullish(),
});
export type SessionMonitorSession = z.infer<typeof SessionMonitorSession>;
